// extracted by mini-css-extract-plugin
module.exports = {"root":"BillingView_root__1KoJV","selectPaymentMethod":"BillingView_selectPaymentMethod__1AQ7J","cardSection":"BillingView_cardSection__12VCB","title":"BillingView_title__wfegW"};